<div class="main-container" *ngIf="!isLoading" data-cy="forms-builder-preview-container">
  <div class="action-container" data-cy="forms-builder-preview-action-container">
    <h4 class="preview-title" data-cy="forms-builder-preview-title">Form Preview</h4>

    <button mat-icon-button class="close-button" (click)="close()" data-cy="forms-builder-preview-close-button"><i class="material-icons">close</i></button>
    <mat-checkbox class="color-checkbox" [(ngModel)]="mobilePreview" (ngModelChange)="resetView()" data-cy="forms-builder-preview-mobile-checkbox">Mobile preview</mat-checkbox>
    <mat-checkbox class="color-checkbox" [(ngModel)]="colorGuides" data-cy="forms-builder-preview-color-checkbox">Color guides</mat-checkbox>
  </div>

  <div class="form-preview-container" [class.mobile-preview]="mobilePreview" data-cy="forms-builder-preview-form-container">
    <div *ngIf="!refreshingView" data-cy="forms-builder-preview-form-view">
      <app-forms-form [cfgFormVersion]="cfgFormVersion"
                      [isPreviewMode]="true"
                      [colorGuides]="colorGuides"
                      [saveEnabled]="false"
                      [actionsEnabled]="false"
                      data-cy="forms-builder-preview-form"></app-forms-form>
    </div>
  </div>


</div>
